import { render, staticRenderFns } from "./TestTypeEdit.vue?vue&type=template&id=409306d9&"
import script from "./TestTypeEdit.vue?vue&type=script&lang=js&"
export * from "./TestTypeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports